/** * @name: org-panel-body * @author: weiyong * @date: 2023-02-21 23:47 *
@description：org-panel-body * @update: 2023-02-21 23:47 */
<template>
  <div class="org-panel-body wh100b">
    <div class="top-cell">
      <a-tree
        :showLine="true"
        @select="selectOrg"
        v-model:expandedKeys="expandedKeys"
        v-model:selectedKeys="selectedKeys"
        :tree-data="orgTreeList"
      />
    </div>
    <a-divider style="border-top: 1px solid #dfdfdf;position: relative;">
      <span class="user-bar-line">{{ t("用户信息") }}</span>
      <div><a-input placeholder="请输入用户名" size="small" style="z-index:9999;position: absolute;left:12px;top:20px;padding:0 12px;width: 180px;" v-model:value="searchUserName"/></div>
      <a-button v-if="multiple||multiple==='true'" @click="selAll" size="small" type="primary" style="z-index:9999;position: absolute;right:89px;top:20px;padding:0 12px;">全选</a-button>
      <a-button v-if="multiple||multiple==='true'" @click="selNotAll" size="small" style="z-index:9999;position: absolute;right:20px;top:20px;padding:0 12px;">反选</a-button>
    </a-divider>
    <div class="bottom-cell">
      <search-user-panel-body
          ref="useSelPanelRef"
          :total="total"
          :pageSize="pageSize"
          :current="current"
          @onShowSizeChange="onShowSizeChange"
        :alreadySelUsers="alreadySelUsers"
        @selItemRecord="selItemRecord"
        :searchUserList="searchUserList"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useOrgSel } from "../hooks/useOrgSel";
import SearchUserPanelBody from "../panelBody/search-user-panel-body.vue";
import { Tree as aTree, Divider as aDivider } from "ant-design-vue";
import { ref } from "vue";
import type { TreeProps } from "ant-design-vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const props = defineProps({
  multiple:{},
  alreadySelUsers: {},
});
const { alreadySelUsers } = toRefs(props);

const { orgTreeList, expandedKeys, searchUserList, selectOrg, flushOrgList,
  total,
  onShowSizeChange,
  pageSize,
  current,
} = useOrgSel(alreadySelUsers);
const emits = defineEmits(["selItemRecord"]);
/**
 * 选择记录
 */
const selItemRecord = function ({ item }) {
  emits("selItemRecord", { item });
};
const selectedKeys = ref<string[]>([]);

const useSelPanelRef=ref(null);
const selAll=function (){
  useSelPanelRef.value?.selAll();
}
const selNotAll=function (){
  useSelPanelRef.value?.selNotAll();
}
const searchUserName=ref('');
defineExpose({ flushOrgList });
watch(()=>unref(searchUserName),(val)=>{
  unref(searchUserList).forEach((itemObj)=>{
    if(itemObj.realName.indexOf(val)>=0){
      itemObj.showFlag=true;
    }else{
      itemObj.showFlag=false;
    }
  })
})
</script>

<style type="text/css" lang="less">
.org-panel-body {
  height: calc(100% - 48px);

  .user-bar-line{
    font-size: 14px; color: #888;
    font-weight: 500;
  }

  .top-cell {
    height: calc((80vh - 130px) / 2);
    overflow: auto;
    padding: 12px 0 12px 20px;
  }

  .bottom-cell {
    height: calc((80vh - 130px) / 2);
    overflow: auto;
  }
}
</style>
